import { cn } from '@/lib/utils';
import { comparisonRows, deploymentOptions } from '../data';
import type { ModelId } from '../types';

const ComparisonSection = ({ model }: { model: ModelId }) => (
  <section className="my-14">
    <h2 className="mb-1.5 text-3xl leading-[1.15] font-semibold tracking-tight">Side by side</h2>
    <p className="mb-6 max-w-[60ch] text-muted-foreground">
      The same Somatiq PACS, RIS, viewer and AI-assisted reporting in every model. What changes is where it runs.
    </p>
    <div className="overflow-x-auto rounded-[18px] border border-border bg-card" tabIndex={0} role="region" aria-label="Deployment comparison">
      <table className="w-full min-w-[720px] border-collapse text-[15.5px]">
        <thead>
          <tr className="border-b border-secondary">
            <th scope="col"><span className="sr-only">Feature</span></th>
            {deploymentOptions.map(option => (
              <th key={option.id} scope="col" className="px-[18px] py-3.5 text-left align-top text-[17px]" style={{ color: option.accent }}>{option.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {comparisonRows.map(row => (
            <tr key={row.label} className="border-b border-secondary last:border-0">
              <th scope="row" className="w-[22%] px-[18px] py-3.5 text-left align-top font-medium text-muted-foreground">{row.label}</th>
              {deploymentOptions.map(option => (
                <td key={option.id} className={cn('px-[18px] py-3.5 align-top', model === option.id && 'bg-(--deployment-tint)')}>
                  {row.values[option.id]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

export default ComparisonSection;
